import { useI18n } from "@/i18n/I18nProvider";

export const HowItWorks = () => {
  const { t } = useI18n();
  const steps = [
    { emoji: "📸", title: t("howit.step1Title"), desc: t("howit.step1Desc"), color: "neon-purple" },
    { emoji: "🎨", title: t("howit.step2Title"), desc: t("howit.step2Desc"), color: "neon-green" },
    { emoji: "⚡", title: t("howit.step3Title"), desc: t("howit.step3Desc"), color: "neon-purple" },
  ];

  return (
    <section id="how" className="py-16 md:py-20 relative">
      <div className="container max-w-5xl">
        <div className="text-center mb-10 space-y-2">
          <h2 className="font-display text-3xl md:text-5xl font-black">
            <span className="text-gradient">{t("howit.title")}</span>
          </h2>
          <p className="text-muted-foreground text-sm md:text-lg">{t("howit.subtitle")}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {steps.map((s, i) => (
            <div
              key={i}
              className="relative rounded-2xl border border-border bg-card/60 backdrop-blur p-6 hover:border-neon-purple/60 transition-all hover:-translate-y-1"
            >
              <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-background border-2 border-neon-purple grid place-items-center font-display font-black text-neon-purple drop-shadow-[0_0_10px_hsl(var(--neon-purple))]">
                {i + 1}
              </div>
              <div className="text-5xl mb-4">{s.emoji}</div>
              <h3 className="font-display font-bold text-lg mb-2">{s.title}</h3>
              <p className="text-sm text-muted-foreground">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
